import { useQuery, UseQueryOptions } from 'react-query';

import { Guid, SearchResult } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';
import { EmptyGuid } from '../../constants';

export function useSecondaryTransactionManagersQuery(
	userGuid: Guid | null | undefined,
	options?: Omit<UseQueryOptions<SearchResult[], unknown, SearchResult[]>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();
	const guid = userGuid ?? EmptyGuid;

	return useQuery(
		QueryKeys.Users.SecondaryTransactionManagers,
		() => AxiosUtils.getResponseData<SearchResult[]>(api.get(CerebroApiEndpoints.Users.TransactionManagers(guid))),
		options
	);
}
